import { Component, inject } from '@angular/core';
import { CardModule } from '@primeng/card';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Table } from '@primeng/table';
import { first } from 'rxjs';
import { NgFooterTemplateDirective } from '@ng-select/ng-select';
import { ModalService } from '@shared/services/modal/modal.service';
import {
  AddPersonComponent
} from '@modules/universal-billing/properties/property-profile/tabs/object-resposible/add-person/add-person.component';
import {SelectableRow} from "@primeng/table/directives/selectable-row.directive";

@Component({
  selector: 'app-property-energy',
  standalone: true,
  imports: [
    CardModule,
    TranslatePipe,
    Table,
    NgFooterTemplateDirective,
    SelectableRow
  ],
  templateUrl: './property-energy.component.html',
  styleUrl: './property-energy.component.scss'
})
export class PropertyEnergyComponent {
  modalService = inject(ModalService);
  translate = inject(TranslateService);

  energyContracts =
    {
      energyClass: 'B',
      heatingType: 'Fernwärme',
      primaryEnergy: '75 kWh/m²a',
      finalEnergy: '62 kWh/m²a',
      energyCertificate: '2019-05-15',
    }

}
